// src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // use "instant" to avoid the smooth animation if you prefer
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search]); // also scroll if query changes
  return null;
}
